var _excluded = ["editor"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Editor as Editor$1, NodeView } from '@tiptap/core';
export * from '@tiptap/core';
import React, { useState, useEffect, createContext, useContext } from 'react';
import { BubbleMenuPlugin } from '@tiptap/extension-bubble-menu';
import { FloatingMenuPlugin } from '@tiptap/extension-floating-menu';
import ReactDOM from 'react-dom';
var BubbleMenu = function BubbleMenu(props) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    element = _useState2[0],
    setElement = _useState2[1];
  useEffect(function () {
    if (!element) {
      return;
    }
    if (props.editor.isDestroyed) {
      return;
    }
    var _props$pluginKey = props.pluginKey,
      pluginKey = _props$pluginKey === void 0 ? 'bubbleMenu' : _props$pluginKey,
      editor = props.editor,
      _props$tippyOptions = props.tippyOptions,
      tippyOptions = _props$tippyOptions === void 0 ? {} : _props$tippyOptions,
      _props$shouldShow = props.shouldShow,
      shouldShow = _props$shouldShow === void 0 ? null : _props$shouldShow;
    var plugin = BubbleMenuPlugin({
      pluginKey: pluginKey,
      editor: editor,
      element: element,
      tippyOptions: tippyOptions,
      shouldShow: shouldShow
    });
    editor.registerPlugin(plugin);
    return function () {
      return editor.unregisterPlugin(pluginKey);
    };
  }, [props.editor, element]);
  return /*#__PURE__*/React.createElement("div", {
    ref: setElement,
    className: props.className,
    style: {
      visibility: 'hidden'
    }
  }, props.children);
};
var Editor = /*#__PURE__*/function (_Editor$) {
  _inherits(Editor, _Editor$);
  var _super = _createSuper(Editor);
  function Editor() {
    var _this;
    _classCallCheck(this, Editor);
    _this = _super.apply(this, arguments);
    _this.contentComponent = null;
    return _this;
  }
  return _createClass(Editor);
}(Editor$1);
var FloatingMenu = function FloatingMenu(props) {
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    element = _useState4[0],
    setElement = _useState4[1];
  useEffect(function () {
    if (!element) {
      return;
    }
    if (props.editor.isDestroyed) {
      return;
    }
    var _props$pluginKey2 = props.pluginKey,
      pluginKey = _props$pluginKey2 === void 0 ? 'floatingMenu' : _props$pluginKey2,
      editor = props.editor,
      _props$tippyOptions2 = props.tippyOptions,
      tippyOptions = _props$tippyOptions2 === void 0 ? {} : _props$tippyOptions2,
      _props$shouldShow2 = props.shouldShow,
      shouldShow = _props$shouldShow2 === void 0 ? null : _props$shouldShow2;
    var plugin = FloatingMenuPlugin({
      pluginKey: pluginKey,
      editor: editor,
      element: element,
      tippyOptions: tippyOptions,
      shouldShow: shouldShow
    });
    editor.registerPlugin(plugin);
    return function () {
      return editor.unregisterPlugin(pluginKey);
    };
  }, [props.editor, element]);
  return /*#__PURE__*/React.createElement("div", {
    ref: setElement,
    className: props.className,
    style: {
      visibility: 'hidden'
    }
  }, props.children);
};
function useForceUpdate() {
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    setValue = _useState6[1];
  return function () {
    return setValue(function (value) {
      return value + 1;
    });
  };
}
var useEditor = function useEditor() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    editor = _useState8[0],
    setEditor = _useState8[1];
  var forceUpdate = useForceUpdate();
  useEffect(function () {
    var instance = new Editor(options);
    setEditor(instance);
    instance.on('transaction', function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          forceUpdate();
        });
      });
    });
    return function () {
      instance.destroy();
    };
  }, deps);
  return editor;
};
function isClassComponent(Component) {
  return !!(typeof Component === 'function' && Component.prototype && Component.prototype.isReactComponent);
}
function isForwardRefComponent(Component) {
  var _a;
  return !!(_typeof(Component) === 'object' && ((_a = Component.$$typeof) === null || _a === void 0 ? void 0 : _a.toString()) === 'Symbol(react.forward_ref)');
}
var ReactRenderer = /*#__PURE__*/function () {
  function ReactRenderer(component, _ref) {
    var editor = _ref.editor,
      _ref$props = _ref.props,
      props = _ref$props === void 0 ? {} : _ref$props,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
    _classCallCheck(this, ReactRenderer);
    this.ref = null;
    this.id = Math.floor(Math.random() * 0xFFFFFFFF).toString();
    this.component = component;
    this.editor = editor;
    this.props = props;
    this.element = document.createElement(as);
    this.element.classList.add('react-renderer');
    if (className) {
      var _this$element$classLi;
      (_this$element$classLi = this.element.classList).add.apply(_this$element$classLi, _toConsumableArray(className.split(' ')));
    }
    this.render();
  }
  _createClass(ReactRenderer, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _a;
      var Component = this.component;
      var props = this.props;
      if (isClassComponent(Component) || isForwardRefComponent(Component)) {
        props.ref = function (ref) {
          _this2.ref = ref;
        };
      }
      this.reactElement = /*#__PURE__*/React.createElement(Component, _objectSpread({}, props));
      if ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.contentComponent) {
        this.editor.contentComponent.setState({
          renderers: this.editor.contentComponent.state.renderers.set(this.id, this)
        });
      }
    }
  }, {
    key: "updateProps",
    value: function updateProps() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.props = _objectSpread(_objectSpread({}, this.props), props);
      this.render();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _a;
      if ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.contentComponent) {
        var renderers = this.editor.contentComponent.state.renderers;
        renderers.delete(this.id);
        this.editor.contentComponent.setState({
          renderers: renderers
        });
      }
    }
  }]);
  return ReactRenderer;
}();
var ReactNodeViewContext = /*#__PURE__*/createContext({
  onDragStart: undefined
});
var useReactNodeView = function useReactNodeView() {
  return useContext(ReactNodeViewContext);
};
var ReactNodeView = /*#__PURE__*/function (_NodeView) {
  _inherits(ReactNodeView, _NodeView);
  var _super2 = _createSuper(ReactNodeView);
  function ReactNodeView() {
    _classCallCheck(this, ReactNodeView);
    return _super2.apply(this, arguments);
  }
  _createClass(ReactNodeView, [{
    key: "mount",
    value: function mount() {
      var _this3 = this;
      var props = {
        editor: this.editor,
        node: this.node,
        decorations: this.decorations,
        selected: false,
        extension: this.extension,
        getPos: function getPos() {
          return _this3.getPos();
        },
        updateAttributes: function updateAttributes() {
          var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return _this3.updateAttributes(attributes);
        },
        deleteNode: function deleteNode() {
          return _this3.deleteNode();
        }
      };
      if (!this.component.displayName) {
        var capitalizeFirstChar = function capitalizeFirstChar(string) {
          return string.charAt(0).toUpperCase() + string.substring(1);
        };
        this.component.displayName = capitalizeFirstChar(this.extension.name);
      }
      var ReactNodeViewProvider = function ReactNodeViewProvider(componentProps) {
        var Component = _this3.component;
        var onDragStart = _this3.onDragStart.bind(_this3);
        var nodeViewContentRef = function nodeViewContentRef(element) {
          if (element && _this3.contentDOMElement && element.firstChild !== _this3.contentDOMElement) {
            element.appendChild(_this3.contentDOMElement);
          }
        };
        return /*#__PURE__*/React.createElement(ReactNodeViewContext.Provider, {
          value: {
            onDragStart: onDragStart,
            nodeViewContentRef: nodeViewContentRef
          }
        }, /*#__PURE__*/React.createElement(Component, _objectSpread({}, componentProps)));
      };
      ReactNodeViewProvider.displayName = 'ReactNodeView';
      this.contentDOMElement = this.node.isLeaf ? null : document.createElement(this.node.isInline ? 'span' : 'div');
      if (this.contentDOMElement) {
        // For some reason the whiteSpace prop is not inherited properly in Chrome and Safari
        // With this fix it seems to work fine
        // See: https://github.com/ueberdosis/tiptap/issues/1197
        this.contentDOMElement.style.whiteSpace = 'inherit';
      }
      var as = this.node.isInline ? 'span' : 'div';
      if (this.options.as) {
        as = this.options.as;
      }
      this.renderer = new ReactRenderer(ReactNodeViewProvider, {
        editor: this.editor,
        props: props,
        as: as,
        className: "node-".concat(this.node.type.name)
      });
    }
  }, {
    key: "dom",
    get: function get() {
      var _a;
      if (this.renderer.element.firstElementChild && !((_a = this.renderer.element.firstElementChild) === null || _a === void 0 ? void 0 : _a.hasAttribute('data-node-view-wrapper'))) {
        throw Error('Please use the NodeViewWrapper component for your node view.');
      }
      return this.renderer.element;
    }
  }, {
    key: "contentDOM",
    get: function get() {
      if (this.node.isLeaf) {
        return null;
      }
      return this.contentDOMElement;
    }
  }, {
    key: "update",
    value: function update(node, decorations) {
      var _this4 = this;
      var _updateProps = function updateProps(props) {
        _this4.renderer.updateProps(props);
      };
      if (node.type !== this.node.type) {
        return false;
      }
      if (typeof this.options.update === 'function') {
        var oldNode = this.node;
        var oldDecorations = this.decorations;
        this.node = node;
        this.decorations = decorations;
        return this.options.update({
          oldNode: oldNode,
          oldDecorations: oldDecorations,
          newNode: node,
          newDecorations: decorations,
          updateProps: function updateProps() {
            return _updateProps({
              node: node,
              decorations: decorations
            });
          }
        });
      }
      if (node === this.node && this.decorations === decorations) {
        return true;
      }
      this.node = node;
      this.decorations = decorations;
      _updateProps({
        node: node,
        decorations: decorations
      });
      return true;
    }
  }, {
    key: "selectNode",
    value: function selectNode() {
      this.renderer.updateProps({
        selected: true
      });
    }
  }, {
    key: "deselectNode",
    value: function deselectNode() {
      this.renderer.updateProps({
        selected: false
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.renderer.destroy();
      this.contentDOMElement = null;
    }
  }]);
  return ReactNodeView;
}(NodeView);
function ReactNodeViewRenderer(component, options) {
  return function (props) {
    // try to get the parent component
    // this is important for vue devtools to show the component hierarchy correctly
    // maybe it’s `undefined` because <editor-content> isn’t rendered yet
    if (!props.editor.contentComponent) {
      return {};
    }
    return new ReactNodeView(component, props, options);
  };
}
var Portals = function Portals(_ref2) {
  var renderers = _ref2.renderers;
  return /*#__PURE__*/React.createElement(React.Fragment, null, Array.from(renderers).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      renderer = _ref4[1];
    return /*#__PURE__*/ReactDOM.createPortal(renderer.reactElement, renderer.element, key);
  }));
};
var PureEditorContent = /*#__PURE__*/function (_React$Component) {
  _inherits(PureEditorContent, _React$Component);
  var _super3 = _createSuper(PureEditorContent);
  function PureEditorContent(props) {
    var _this5;
    _classCallCheck(this, PureEditorContent);
    _this5 = _super3.call(this, props);
    _this5.editorContentRef = /*#__PURE__*/React.createRef();
    _this5.state = {
      renderers: new Map()
    };
    return _this5;
  }
  _createClass(PureEditorContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.init();
    }
  }, {
    key: "init",
    value: function init() {
      var editor = this.props.editor;
      if (editor && editor.options.element) {
        if (editor.contentComponent) {
          return;
        }
        var element = this.editorContentRef.current;
        element.append.apply(element, _toConsumableArray(editor.options.element.childNodes));
        editor.setOptions({
          element: element
        });
        editor.contentComponent = this;
        editor.createNodeViews();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var editor = this.props.editor;
      if (!editor) {
        return;
      }
      if (!editor.isDestroyed) {
        editor.view.setProps({
          nodeViews: {}
        });
      }
      editor.contentComponent = null;
      if (!editor.options.element.firstChild) {
        return;
      }
      var newElement = document.createElement('div');
      newElement.append.apply(newElement, _toConsumableArray(editor.options.element.childNodes));
      editor.setOptions({
        element: newElement
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        editor = _this$props.editor,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _objectSpread({
        ref: this.editorContentRef
      }, rest)), /*#__PURE__*/React.createElement(Portals, {
        renderers: this.state.renderers
      }));
    }
  }]);
  return PureEditorContent;
}(React.Component);
var EditorContent = /*#__PURE__*/React.memo(PureEditorContent);
var NodeViewWrapper = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useReactNodeView = useReactNodeView(),
    onDragStart = _useReactNodeView.onDragStart;
  var Tag = props.as || 'div';
  return /*#__PURE__*/React.createElement(Tag, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    "data-node-view-wrapper": "",
    onDragStart: onDragStart,
    style: _objectSpread(_objectSpread({}, props.style), {}, {
      whiteSpace: 'normal'
    })
  }));
});
var NodeViewContent = function NodeViewContent(props) {
  var Tag = props.as || 'div';
  var _useReactNodeView2 = useReactNodeView(),
    nodeViewContentRef = _useReactNodeView2.nodeViewContentRef;
  return /*#__PURE__*/React.createElement(Tag, _objectSpread(_objectSpread({}, props), {}, {
    ref: nodeViewContentRef,
    "data-node-view-content": "",
    style: _objectSpread(_objectSpread({}, props.style), {}, {
      whiteSpace: 'pre-wrap'
    })
  }));
};
export { BubbleMenu, Editor, EditorContent, FloatingMenu, NodeViewContent, NodeViewWrapper, PureEditorContent, ReactNodeViewRenderer, ReactRenderer, useEditor };